import { Checkbox, ListItemText, MenuItem, Select } from "@mui/material";
import { TransactionType, TransactionTypeNames } from "../shared/Consts";
import _ from "lodash";
import useActionFilter, { FILTER_ACTIONS } from "../portlibs/ActionFilterProvider";

export default function ActionFilter(){
    const {actions,setActions} = useActionFilter()

    const list = FILTER_ACTIONS.map(action => {
        return <MenuItem key={action} value={action}>
            <Checkbox checked={actions.includes(action)}/>
            <ListItemText primary={TransactionTypeNames.get(action)}/>
        </MenuItem>
    })

    const onActionFilter = (values:TransactionType[]) => {
        if (actions.includes(TransactionType.all) && !values.includes(TransactionType.all)) setActions([])
        else if (!actions.includes(TransactionType.all) && values.includes(TransactionType.all)) setActions([...FILTER_ACTIONS])
        else if (values.length<FILTER_ACTIONS.length && values.includes(TransactionType.all)) {
            _.pull(values, TransactionType.all)
            setActions([...values])
        }
        else if (values.length+1==FILTER_ACTIONS.length) setActions([...FILTER_ACTIONS])
        else setActions([...values])
    }

    const onChange = (e:any) => onActionFilter(e.target.value)
    return <Select className="dropdown action-list" defaultValue={FILTER_ACTIONS} multiple value={actions} onChange={onChange}>
        {list}
    </Select>
}